import {Injectable} from '@angular/core';
import {NgbDateAdapter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ObjectUtil} from "../../utils/object-util";

@Injectable()
export class CustomDateAdapterService extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: any): NgbDateStruct | null {
    if (!ObjectUtil.isEmpty(value)) {
      let date;
      if (value?.hasOwnProperty('date')) {
        if (value?.date?.hasOwnProperty('date')) {
          date = value?.date?.date?.split(this.DELIMITER);
        } else {
          date = value?.date?.split(this.DELIMITER);
        }
      } else {
        date = value?.split(this.DELIMITER);
      }
      if (!ObjectUtil.isEmpty(date)) {
        return {
          day: parseInt(date[2], 10),
          month: parseInt(date[1], 10),
          year: parseInt(date[0], 10)
        };
      }
      return null;
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.year + this.DELIMITER + ('00' + date.month).slice(-2) + this.DELIMITER + ('00' + date.day).slice(-2) : null;
  }
}
